import { render } from "./SkuForm.vue?vue&type=template&id=833c83c0"
import script from "./SkuForm.vue?vue&type=script&lang=js"
export * from "./SkuForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__